import { format } from 'date-fns'
import CONSTANTS from '../Constants'
import { REVOKE_ACCESS_API } from '../Constants/ApiDefinations'
import mainApiService from '../Services'
import { REVOKE_ACCESS_MODULE_ROUTE_MAP } from '../Constants/Constant'

const formatActiveWindowMessage = (text: string, identifier = '$'): string => {
  if (!text) return ''
  const regex = new RegExp(
    `\\${identifier}(\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{3}Z)`,
    'g',
  )
  return text.replace(regex, (_match, utcDateStr) =>
    format(new Date(utcDateStr), CONSTANTS.DATE_FORMAT_TIME_SECONDS),
  )
}

export const checkActiveWindow = async (
  moduleName: string,
): Promise<{ message: string; actions: string[] }> => {
  if (moduleName) {
    const activeWindow = REVOKE_ACCESS_API.CHECK_ACTIVE_WINDOW(moduleName)
    const result: any = await mainApiService(activeWindow)
    if (result?.responseCode === 200) {
      const actions = result?.data?.modules?.[0]?.actions
      return {
        message: formatActiveWindowMessage(result?.message) || '',
        actions: Array.isArray(actions) ? actions : [],
      }
    }
  }
  return { message: '', actions: [] }
}

export const getRevokeAccessModuleFromUrl = (pathname: string): string => {
  const segments = pathname.split('/').filter(Boolean)
  const matchedSegment = segments.find((segment) =>
    Object.prototype.hasOwnProperty.call(REVOKE_ACCESS_MODULE_ROUTE_MAP, segment),
  )
  return matchedSegment ? REVOKE_ACCESS_MODULE_ROUTE_MAP[matchedSegment] : ''
}

export const isCtaDisabledForActiveWindow = (
  isActiveWindow: boolean,
  actions: string[],
  ctaAction?: string,
): boolean => {
  if (!isActiveWindow) return false
  if (Array.isArray(actions) && actions.length > 0 && ctaAction) {
    return actions.includes(ctaAction)
  }
  return true
}
